// Generalized customer invoice in the DOSS PO-family design (reusable across partners).
// Generated by scripts/wms/generate.ts for PHP-408. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomInvoiceFileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    legalName: yup.string().nullable().optional(),
    remitAddressLine1: yup.string().nullable().optional(),
    remitAddressLine2: yup.string().nullable().optional(),
    remitCity: yup.string().nullable().optional(),
    remitState: yup.string().nullable().optional(),
    remitPostalCode: yup.string().nullable().optional(),
    arEmail: yup.string().nullable().optional(),
  }),
  billTo: yup.object().shape({
    tradingPartnerName: yup.string().nullable().optional(),
    buyingPartyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    city: yup.string().nullable().optional(),
    state: yup.string().nullable().optional(),
    postalCode: yup.string().nullable().optional(),
  }),
  invoiceNumber: yup.string().nullable().optional(),
  invoiceDate: yup.string().nullable().optional(),
  dueDate: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  shipDate: yup.string().nullable().optional(),
  poNumber: yup.string().nullable().optional(),
  dcNumber: yup.string().nullable().optional(),
  internalVendorNumber: yup.string().nullable().optional(),
  departmentNumber: yup.string().nullable().optional(),
  bolNumber: yup.string().nullable().optional(),
  scac: yup.string().nullable().optional(),
  transportationMethod: yup.string().nullable().optional(),
  ediTerms: yup.object().shape({
    termsTypeCode: yup.string().nullable().optional(),
    basisDateCode: yup.string().nullable().optional(),
    discountPercent: yup.string().nullable().optional(),
    discountDaysDue: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        lineNumber: yup.number().nullable().optional(),
        assignedId: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        buyerCatalogNumber: yup.string().nullable().optional(),
        upc: yup.string().nullable().optional(),
        buyerItemNumber: yup.string().nullable().optional(),
        countryOfOrigin: yup.string().nullable().optional(),
        qty: yup.string().nullable().optional(),
        uom: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        discount: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
      }),
    )
    .required(),
  adjustments: yup
    .array()
    .of(
      yup.object().shape({
        label: yup.string().nullable().optional(),
        amount: yup.string().nullable().optional(),
      }),
    )
    .required(),
  totalUnits: yup.string().nullable().optional(),
  lineCount: yup.string().nullable().optional(),
  subtotal: yup.string().nullable().optional(),
  invoiceAmount: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
  remittance: yup.object().shape({
    routingNumber: yup.string().nullable().optional(),
    accountNumber: yup.string().nullable().optional(),
    bankName: yup.string().nullable().optional(),
    bankAddress: yup.string().nullable().optional(),
    beneficiaryName: yup.string().nullable().optional(),
    beneficiaryAddress: yup.string().nullable().optional(),
  }),
})

export type BiomInvoiceFileData = yup.InferType<typeof biomInvoiceFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<BiomInvoiceFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomInvoiceFileMappings: RequiredFileData = {
  issuer: {
    companyName: '0819e9f1-1531-4de7-b118-a9c39c962d08',
    legalName: 'cfcaf99f-3113-4dea-a303-9b6601223668',
    remitAddressLine1: '7fb4471b-78a1-462c-8713-b72790cd7b1c',
    remitAddressLine2: '7f74af8e-fa02-4615-8482-52f5355f87e9',
    remitCity: '13fcd241-581e-4522-8549-efaf076748e2',
    remitState: 'd8a37a21-fae8-4c64-a051-8dccd74d8899',
    remitPostalCode: '1d0e7f4a-50e9-4e8b-a091-1c41697159c4',
    arEmail: '865bfac4-024a-4821-be1a-f31ced0f829c',
  },
  billTo: {
    tradingPartnerName: '8850eaf1-7383-4b37-b12e-cec41a66a6df',
    buyingPartyName: '64328f4d-ddb0-4e6b-bffc-31bbe9eef920',
    addressLine1: '70bbd1a3-7568-4119-86cc-d80300d5c9e7',
    addressLine2: '516e570b-4761-43d3-b067-bc938fb0a1ec',
    city: '9ac88fa1-e694-44bd-a38d-c88862346faa',
    state: '80002ebc-7df5-48c2-a321-f4855b05b621',
    postalCode: '0ec7bad6-fde9-43c3-aa75-a01886f645db',
  },
  invoiceNumber: '87765947-ede9-4d18-abd7-2980eb7e57a8',
  invoiceDate: '2e6779bc-c450-446f-966f-b54dc06ff0fc',
  dueDate: '498352b9-9310-470b-9e22-899e2865a896',
  paymentTerms: 'ddd0d251-ebcc-4ff3-9e8e-57eeac71adb8',
  shipDate: '5742b5b3-4b56-4e4a-b014-6ce57718fa50',
  poNumber: 'c428006b-4a66-4fb9-a0b9-93c52022e023',
  dcNumber: '9aa94b29-c845-4558-8a93-1cbcc90fa673',
  internalVendorNumber: '65728061-c3b7-49e9-8289-82df0dd7ea2b',
  departmentNumber: '78df016c-20c2-45c6-9f1c-c5a04edbd1dc',
  bolNumber: 'b7baa736-68a5-47ac-92f2-ffe7f343a9a8',
  scac: '838571ac-7de7-43d8-a782-bbe98a35d7be',
  transportationMethod: 'd39692f4-2aab-477a-a1dc-37c062a55fc0',
  ediTerms: {
    termsTypeCode: '91c292ca-cebf-4c60-88aa-8d95ea1244d1',
    basisDateCode: 'ebbf40d1-2463-454e-a2d0-0e9e439e70c5',
    discountPercent: '54841b90-4700-49e8-ba24-41004522b650',
    discountDaysDue: '9ae5c8cc-65a5-4bbf-8149-78d57394e09c',
  },
  items: [
    {
      lineNumber: null,
      assignedId: 'ecc6fba0-320c-4633-8729-97ce1f2196b8',
      description: '0380f014-c00a-48e9-a351-7bafd646700d',
      buyerCatalogNumber: 'ed5391c3-9bbc-42c8-a0dd-43b6873edfc9',
      upc: '42967059-7b1f-478a-aeb8-490d2b1cc3d6',
      buyerItemNumber: 'fa952dac-a84a-466f-88f4-ed4dd373c11b',
      countryOfOrigin: '4f5b9c69-4272-4970-a451-725104f6e995',
      qty: 'a8735309-0a47-41a1-a0a3-4684cbeac617',
      uom: '07fbce2f-16af-4905-ab13-f60b64a4f2ca',
      unitPrice: '36a7d01f-ab7c-4414-bcb4-40780ea1324d',
      discount: '989c76c9-b6ba-45cf-960a-4f85168b36af',
      lineTotal: 'c8c4efa4-f590-42ac-a85f-1b9627bdf54e',
    },
  ],
  adjustments: [
    {
      label: '68cd630d-b735-417f-8874-a52b81ff3f6e',
      amount: '95ec3063-5abe-4f86-830e-7a779089488a',
    },
  ],
  totalUnits: '7b9350a3-0210-4d5c-8248-a7feaf7861ce',
  lineCount: 'd732edfb-3eed-433e-821b-c3d72b736080',
  subtotal: '59c5b464-f99b-47f7-b3c4-bfdec1a7df1f',
  invoiceAmount: 'cd0db808-3874-44ce-949d-7e96f347f86f',
  comments: '0f0034b4-3885-473d-a06f-d0d38214df28',
  remittance: {
    routingNumber: '445cebad-0e1d-456d-8199-e780cc9e6c45',
    accountNumber: '29e65008-99c8-4a8a-a49f-859ef305886a',
    bankName: '77d07bd6-ec79-40af-a5d8-c61ce9f27697',
    bankAddress: '4971d269-fa31-47b3-9353-8dd9d39b23ac',
    beneficiaryName: '7f6e8aca-99c6-4755-863a-b4d8fa9867dd',
    beneficiaryAddress: '3d3dcaed-a2da-439c-b262-dddd8b94d76c',
  },
}
